// extracted by mini-css-extract-plugin
export default {"title":"SellerInfo_title__5rhdB","sellerType":"SellerInfo_sellerType__Ebmp+","middleName":"SellerInfo_middleName__-c--u"};